import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useMemo, useState } from 'react';
import { SchedStatusDialog } from './SchedStatusDialog';

export const SchedList = () => {
  const { openDialog } = useDialog();
  const [selectedEntities, setSelectedEntities] = useState([]);

  const selectedIds = useMemo(() => selectedEntities.map((entity) => entity.id), [selectedEntities]);

  const handleSelectionChanged = (event) => {
    const selectedNodeData = event.api.getSelectedNodes().map((node) => node.data);
    setSelectedEntities(selectedNodeData);
  };

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };

  const augButtons = (buttons) => {
    // Reflect the aggregate selection: toggle-on when more selected schedules are active than inactive.
    const activeCount = selectedEntities.filter((entity) => entity.status === 'ACTIVE').length;
    const on = activeCount > selectedEntities.length - activeCount;
    buttons.push(
      <TitleButton
        key="schedStatusButton"
        icon={on ? fas.faToggleOn : fas.faToggleOff}
        toolTip="Set Status"
        disabled={selectedEntities.length === 0}
        onClick={() => openDialog(SchedStatusDialog, { data: { ids: selectedIds } })}
      />,
    );
  };

  return (
    <EntityList
      entity="SCHED"
      augFieldDefs={augFieldDefs}
      augButtons={augButtons}
      gridOptions={{
        rowSelection: 'multiple',
      }}
      events={{
        onSelectionChanged: handleSelectionChanged,
      }}
    />
  );
};
